import Vue from 'vue'

export default {
  login ({ commit, dispatch }, data) {
    return Vue.api.post('login/signin', data)
      .then((res) => commit('init', { token: res.data }))
      .then(() => dispatch('auth'))
  },
  signup ({ commit, dispatch }, data) {
    return Vue.api.post('login/signup', data, { withCredentials: true })
      .then((res) => commit('init', { token: res.data }))
      .then(() => dispatch('auth'))
  },
  resetAccount ({ commit }, data) {
    if (data.token) {
      return Vue.api.put('login/reset', data)
    } else {
      return Vue.api.post('login/reset', data)
    }
  },
  getUser ({ commit }) {
    return Vue.api.get('engine/me')
      .then((res) => commit('init', { user: res.data }))
  },
  updateUser ({ commit }, data) {
    return Vue.api.post('engine/account', data)
      .then((res) => commit('init', { user: res.data }))
  },
  createProject ({ dispatch }, data) {
    return Vue.api.post('engine/account/project', data)
      .then(() => dispatch('getUser'))
  },
  updateProject ({ dispatch }, data) {
    return Vue.api.put('engine/account/project', data)
      .then(() => dispatch('getUser'))
  },
  generateKey ({ commit }, data) {
    return Vue.api.post('engine/account/generate-key', data)
  },
  declineInvitation ({ commit }, invitationId) {
    return Vue.api.delete('engine/invitations/' + invitationId)
  },
  acceptInvitation ({ commit }, invitationId) {
    return Vue.api.post('engine/invitations/' + invitationId).then((res) => res.data)
  }
}
